module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioPrimerExamenReg1FIS3.439ec1a1.pdf";